import BaseWidget from './BaseWidget';

class BaseDashboard<T extends BaseWidget> {
	Id: number;
	Name: string;
	Widgets: T[];
}

export default BaseDashboard;